<template>
    <div>
        <dx-grid
            url="foodDistributionSiblings"
            :columns="columns"
            :title="title"
            :allowEditing="true"
            :allowDeleting="true"
            :updateRow="saveSibling"
            :deleteRow="deleteSibling"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            ref="grid"
        ></dx-grid></div
></template>
<script>
import moment from "moment";

export default {
    data: () => ({
        title: "Siblings",
        columns: [
            {
                label: "Family ID",
                field: "familyID",
                link: "FoodDistributionFamilyView",
                format: "",
                template: "link-cell-template",
                visible: true,
                sortOrder: "asc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Father",
                field: "father",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Father Hebrew",
                field: "fatherH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Home Phone",
                field: "homePhone",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Cell Phone",
                field: "cellPhone",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Grade",
                field: "class",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Age",
                field: "age",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Recording",
                template: "link-audio-cell-template",
                field: "nameRecordingURL",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Is UTA",
                field: "isUta",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "Name Confirmed",
                field: "nameConfirmed",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: false,
            },
            {
                label: "Confirmed By",
                field: "confirmedBy",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "DOB",
                field: "dob",
                type: "date",
                format: "MM/dd/yyyy",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Enrolled Date",
                field: "enrolledDate",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Confirmed At",
                field: "confirmedAt",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Translated At",
                field: "translatedAt",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        actions: [],
        url: "",
        user: "",
        processing: false,

        today: moment().format("YYYY-MM-DD HH:mm:ss"),

        rules: {
            required: (v) => {
                return !!v || "Required";
            },
        },
    }),
    created() {
        this.user = this.$store.state.authentication.user;
    },
    mounted() {},
    methods: {
        onRowClicked(row) {
            this.$router.push({
                name: "FoodDistributionFamilyView",
                params: { id: row.familyID.trim() },
            });
        },
        async deleteSibling(data) {
            try {
                await this.$http.post(
                    "api/foodDistributionSiblings/DeleteSibling?id=" + data.id
                );
            } catch (e) {}
        },
        async saveSibling(data) {
            const updated = Object.assign(data.oldData, data.newData);

            updated.confirmedBy = this.user;

            try {
                await this.$http.post(
                    "api/foodDistributionSiblings/saveSibling",
                    updated
                );

                this.$refs.grid.reloadGrid();
            } catch (e) {}
        },
    },
};
</script>
